export const COOKIE_CATEGORY = {
  STRICTLY_NECESSARY: 'strict',
  PERFORMANCE: 'performance',
  FUNCTIONAL: 'functionality',
  TARGETING: 'targeting',
  UNCLASSIFIED: 'unclassified'
}

export const MAIN_COOKIE_CATEGORY_VALUES = [
  COOKIE_CATEGORY.STRICTLY_NECESSARY,
  COOKIE_CATEGORY.PERFORMANCE,
  COOKIE_CATEGORY.FUNCTIONAL,
  COOKIE_CATEGORY.TARGETING,
  COOKIE_CATEGORY.UNCLASSIFIED
]

export const COOKIE_ENTITY_TYPE = {
  RE_CAPTCHA: 'RE_CAPTCHA',
  YOUTUBE: 'YOUTUBE'
}

/**
 * Full list of prior blocked services
 */
export const REQUIRED_COOKIE_CATEGORIES_BY_COOKIE_ENTITY_TYPE = {
  [COOKIE_ENTITY_TYPE.RE_CAPTCHA]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.YOUTUBE]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.UNCLASSIFIED
  ]
}

export const CMP_CONSENT_COOKIE_NAME = 'CookieScriptConsent'

export const HANDLER_TYPE = {
  GLOBAL: 'global',
  LOCAL: 'local'
}

export const HANDLER_TYPE_BY_ENTITY_TYPE = {
  [COOKIE_ENTITY_TYPE.RE_CAPTCHA]: HANDLER_TYPE.GLOBAL,
  [COOKIE_ENTITY_TYPE.YOUTUBE]: HANDLER_TYPE.LOCAL
}

export const CMP_POPUP_WRAPPER_ID = 'cookiescript_injected_wrapper'

export const CMP_STATE = {
  CA: 'ca'
}

export const CMP_CCPA_CONTACT_US_LINK_TEXT =
  'Do Not Sell or Share My Personal Information'
